<script>
export default {
  name: "HeaderFilter",
  props: {
    options: { type: Array, required: true },
    value: { type: String, default: "" },
    column: { type: String, required: true },
  },
  data() {
    return {
      isOpen: false,
      search: "",
    };
  },
  computed: {
    filteredOptions() {
      return this.options.filter((opt) =>
        opt.toLowerCase().includes(this.search.toLowerCase())
      );
    },
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    selectOption(option) {
      this.$emit("input", option);
      this.isOpen = false;
    },
    clearFilter() {
      this.$emit("input", "");
      this.isOpen = false;
    },
    handleClickOutside(event) {
      if (this.isOpen && !this.$el.contains(event.target)) {
        this.isOpen = false;
      }
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>


<template>
  <div class="relative inline-block text-left">
    <!-- Filter button -->
    <button
      @click="toggleDropdown"
      class="ml-2 px-2 py-1 border bg-white text-xs hover:bg-gray-100"
    >
      <fluent-icon icon="filter"/>
    </button>

    <!-- Dropdown -->
    <div
      v-if="isOpen"
      class="absolute right-0 mt-1 w-40 bg-white border rounded shadow-lg z-20"
    >
      <!-- Search -->
      <input
        type="text"
        v-model="search"
        class="w-full px-2 py-1 border-b text-sm outline-none"
        placeholder="Search..."
      />

      <!-- Options -->
      <ul class="max-h-40 overflow-y-auto">
        <li
          v-for="option in filteredOptions"
          :key="option"
          class="px-2 py-1 cursor-pointer hover:bg-gray-100"
          @click="selectOption(option)"
        >
          {{ option }}
        </li>
      </ul>

      <!-- Clear -->
      <div
        class="px-2 py-1 text-red-500 hover:text-white hover:bg-red-500 text-sm cursor-pointer hover:bg-gray-100 border-t"
        @click="clearFilter"
      >
        Clear
      </div>
    </div>
  </div>
</template>


